import { render, staticRenderFns } from "./AppointmentScheduleDateItem.vue?vue&type=template&id=5f5ef8d4&scoped=true"
import script from "./AppointmentScheduleDateItem.vue?vue&type=script&lang=js"
export * from "./AppointmentScheduleDateItem.vue?vue&type=script&lang=js"
import style0 from "./AppointmentScheduleDateItem.vue?vue&type=style&index=0&id=5f5ef8d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5ef8d4",
  null
  
)

export default component.exports